//Copyright (C) Siemens Healthineers AG 2024, All rights reserved. Restricted
//
(function () {

    'use strict';

    angular.module('container.widgets')
        .directive('srsngOperatorClientStatus', srsngOperatorClientStatus);

    function srsngOperatorClientStatus() {

        return {
            restrict: 'E',
            templateUrl: 'container/ui/app/widgets/operator-client-status/operator-client-status.html',
            scope: {},
            controller: controller
        };

        function controller($scope, $rootScope, Event, operatorClientStatService, OPERATOR_CLIENT_STATUS, operatorClientService, PROTOCOLHANDLER_INSTALLER_URL, operatorClientStatusSharedService) {

            $scope.status = OPERATOR_CLIENT_STATUS.CONNECTING;
            $scope.flyout = {
                visible: false,
                visiblePage: 1
            }
            $scope.protocolHandlerInstallerUrl = PROTOCOLHANDLER_INSTALLER_URL;

            function init() {
                operatorClientStatService.ocStatusService.addCallback(statusChanged);
                operatorClientStatService.ocStatusService.addErrorCallback(errorCallback);
                operatorClientService.addNotConnectedCallbacks(notConnectedCallback);
                operatorClientService.triggerStatService();
                
                operatorClientStatusSharedService.setStatus($scope.status);
                operatorClientStatusSharedService.setFlyoutState($scope.flyout);
            }

            function statusChanged(value) {
                $scope.$safeApply(() => {

                    if (value && value.success) {
                        const tokenExpiresInSeconds = 10;
                        const actualDateInSeconds = Math.floor(Date.now() / 1000);

                        if ((window._keycloak.tokenParsed.exp - actualDateInSeconds) <= tokenExpiresInSeconds) {
                            localStorage.setItem('accessTokenUpdatedBy', 'browser');
                            window._keycloak.updateToken(tokenExpiresInSeconds).then((refreshed) => {
                                if (refreshed) {
                                    console.log('Token refreshed ' + new Date());
                                    $rootScope.$emit(Event.OC_STAT_SERVICE_RESTART);
                                }
                            }).catch(() => {
                                let msg = 'Token refresh failed ' + new Date();
                                console.info(msg);
                                $rootScope.$emit(Event.USER_LOGGED_OUT);
                                window._keycloak.logout();
                            });
                        }

                        let clientState = '';
                        if (value.response && value.response.payload) {
                            clientState = value.response.payload.clientState;
                        }

                        if (clientState === 'online') {
                            $scope.status = OPERATOR_CLIENT_STATUS.ONLINE;
                        } else if (clientState === 'degraded') {
                            $scope.status = OPERATOR_CLIENT_STATUS.DEGRADED;
                        } else {
                            $scope.status = OPERATOR_CLIENT_STATUS.UNDEFINED;
                        }
                    } else {
                        $scope.status = OPERATOR_CLIENT_STATUS.UNDEFINED;
                    }
                    
                    operatorClientStatusSharedService.setStatus($scope.status);
                })

            }

            function errorCallback(error) {
                $scope.$safeApply(() => {
                    $scope.status = OPERATOR_CLIENT_STATUS.ERROR;
                    operatorClientStatusSharedService.setStatus($scope.status);
                });
                console.log(error);

                $rootScope.$emit(Event.OC_ERROR);
            }

            function notConnectedCallback() {
                $scope.$safeApply(() => {
                    $scope.flyout.visible = false;
                    $scope.status = OPERATOR_CLIENT_STATUS.ERROR;
                    operatorClientStatusSharedService.setStatus($scope.status);
                    operatorClientStatusSharedService.setFlyoutState($scope.flyout);
                });
            }

            $scope.toggleFlyout = function () {
                $scope.flyout.visible = !$scope.flyout.visible;
                operatorClientStatusSharedService.setFlyoutState($scope.flyout);
            };

            $scope.restartOC = function () {
                $scope.flyout.visible = false;
                operatorClientService.init().then((success) => {
                    $scope.status = OPERATOR_CLIENT_STATUS.CONNECTING;
                    operatorClientService.trigger(true);
                    operatorClientStatusSharedService.setStatus($scope.status);
                    operatorClientStatusSharedService.setFlyoutState($scope.flyout);
                }, () => {
                    console.log('init of operatoreClientService failed!');
                });
            }

            $scope.guidePageNext = function () {
                $scope.flyout.visiblePage++;
            }

            $scope.guidePagePrev = function () {
                $scope.flyout.visiblePage--;
            }

            $scope.goToPage = function (pageNumber) {
                $scope.flyout.visiblePage = pageNumber;
            }

            $rootScope.$on(Event.OC_STAT_SERVICE_STARTED, (event) => {
                init();
            });


            $scope.$safeApply = function (fn) {
                var phase = this.$root.$$phase;
                if (phase == '$apply' || phase == '$digest') {
                    if (fn && (typeof (fn) === 'function')) {
                        fn();
                    }
                } else {
                    this.$apply(fn);
                }
            };
        }
    }
})();